import { PersonDto } from 'dtos'

export function getComparablePerson({
  personGuid,
  firstName,
  lastName,
  email,
  mobilePhone,
  officePhone
}: PersonDto): PersonDto {
  return {
    personGuid,
    firstName,
    lastName,
    email,
    mobilePhone,
    officePhone
  }
}
